import React, { CSSProperties, FC } from 'react'

import { useWindowSize } from '../hooks/useWindowSize'
import { StarField, StarFieldProps } from './StarField'

const fixedPositionStyle: CSSProperties = {
  position: 'fixed',
  zIndex: -1,
}

export const WindowSizeStarField: FC<StarFieldProps> = ({ style, ...restProps }) => {
  const { innerWidth, innerHeight } = useWindowSize()

  return <StarField
    {...restProps}
    style={{ ...fixedPositionStyle, ...style }}
    width={innerWidth}
    height={innerHeight}
  />
}
